import type { RouteLocation } from '#vue-router'

export const getLastCategoryLevel = (route: RouteLocation) => {
  for (let i = 4; i > -1; i--) {
    if (route.params[`lvl${i}`]) return i
  }
}
